export default __webpack_public_path__ + "static/media/chickennuggets@3x.69bb977f.jpg";